import { useState } from "react";
import styles from "../style/termsOfUse.module.css";
import Features from "../components/features/Features";
import { companyName } from "../Const";

const SECTIONS = [
    {
        id: 1,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
        ),
        title: "Introduction",
        summary: `${companyName} is a digital real estate platform connecting`,
        content: (
            <>
                <p>{companyName} is a digital real estate platform connecting:</p>
                <ul>
                    <li>Property Buyers</li>
                    <li>Sellers</li>
                    <li>Investors</li>
                    <li>Brokers</li>
                    <li>Developers</li>
                    <li>Landlords</li>
                    <li>Tenants</li>
                    <li>Real Estate Agencies</li>
                </ul>
                <p>This Privacy Policy applies to all users who access our platform, services, advertisements, property listings, and communication tools.</p>
            </>
        ),
    },
    {
        id: 2,
        icon: (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="none"
                    strokeWidth="2"
                    d="M6,9 C7.65685425,9 9,7.65685425 9,6 C9,4.34314575 7.65685425,3 6,3 C4.34314575,3 3,4.34314575 3,6 C3,7.65685425 4.34314575,9 6,9 Z M6,3 L6,0 M6,12 L6,9 M0,6 L3,6 M9,6 L12,6 M2,2 L4,4 M8,8 L10,10 M10,2 L8,4 M4,8 L2,10 M18,12 C19.6568542,12 21,10.6568542 21,9 C21,7.34314575 19.6568542,6 18,6 C16.3431458,6 15,7.34314575 15,9 C15,10.6568542 16.3431458,12 18,12 Z M18,6 L18,3 M18,15 L18,12 M12,9 L15,9 M21,9 L24,9 M14,5 L16,7 M20,11 L22,13 M22,5 L20,7 M16,11 L14,13 M9,21 C10.6568542,21 12,19.6568542 12,18 C12,16.3431458 10.6568542,15 9,15 C7.34314575,15 6,16.3431458 6,18 C6,19.6568542 7.34314575,21 9,21 Z M9,15 L9,12 M9,24 L9,21 M3,18 L6,18 M12,18 L15,18 M5,14 L7,16 M11,20 L13,22 M13,14 L11,16 M7,20 L5,22"
                ></path>
            </svg>
        ),
        title: "Our Services",
        summary: "Our services include",
        content: (
            <>
                <p>Our services include:</p>
                <ul>
                    <li>Property ListingsLead Generation</li>
                    <li>Property Advertising</li>
                    <li>Agent Profiles</li>
                    <li>Project Promotions</li>
                    <li>Market InsightsReal Estate Search Tools</li>
                    <li>Communication Services</li>
                    <li>Tenants</li>
                    <li>Real Estate Agencies</li>
                </ul>
                <p>This Privacy Policy applies to all users who access our platform, services, advertisements, property listings, and communication tools.</p>
            </>
        ),
    },
    {
        id: 3,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 1l3 6 6 .9-4.5 4.4 1 6.2L12 16l-5.5 2.5 1-6.2L3 7.9 9 7z" />
            </svg>
        ),
        title: "Information We Collect",
        summary: "We may collect the following categories of information",
        content: (
            <>
                <p> We may collect the following categories of information:</p>
                <b>A. Personal Information</b>
                <p> When you register, inquire, subscribe, or contact us, we may collect:</p>
                <ul>
                    <li>Full Name</li>
                    <li>Email Address</li>
                    <li>Phone Number</li>
                    <li>WhatsApp Number</li>
                    <li>Company Name</li>
                    <li>Property Preferences</li>
                    <li>Location Information</li>
                    <li>Nationality</li>
                    <li>Brokerage Details</li>
                </ul>
                <b>B. Account Information </b>
                <p>When creating an account, we may collect: </p>
                <ul>
                    <li>Profile Image</li>
                    <li>Agency Information</li>
                    <li>License Details</li>
                    <li>Saved Properties</li>
                </ul>
                <b>C. Property Inquiry Information</b>
                <p>When submitting property inquiries or contacting agents:</p>
                <ul>
                    <li>Inquiry Messages</li>
                    <li>Preferred Property Types</li>
                    <li>Budget Information</li>
                    <li>Viewing Requests</li>
                    <li>Saved Properties</li>
                    <li>Communication History</li>
                    <li>Meeting Schedules</li>
                </ul>
                <b>D. Property Listing Information </b>
                <p>For brokers, agencies, and developers:</p>
                <ul>
                    <li>Property Details</li>
                    <li>Listing Images</li>
                    <li>Videos</li>
                    <li>Floor Plans</li>
                    <li>Prices</li>
                    <li>Property Documents</li>
                    <li>Marketing Materials</li>
                </ul>
                <b>E. Cookies & Tracking Technologies</b> <p>{companyName} uses cookies, analytics tools, and tracking technologies to improve functionality and personalize experiences.</p> <b>Cookies help us:</b>
                <ul>
                    <li>Remember user preferences</li>
                    <li>Analyze traffic patterns</li>
                    <li>Improve website speed</li>
                    <li>Deliver targeted advertisements</li>
                    <li>Enable login sessions</li>
                    <li>Enhance platform security</li>
                </ul>
                <bdi>Users may disable cookies through browser settings.</bdi>
            </>
        ),
    },
    {
        id: 4,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21a8 8 0 0 0-16 0" />
                <circle cx="12" cy="7" r="4" />
            </svg>
        ),
        title: "How We Use Your Information",
        summary: "We use collected information to",
        content: (
            <>
                <p>We use collected information to:</p>
                <ul>
                    <li>Provide platform servicesCreate and manage accounts</li>
                    <li>Display relevant property listingsConnect users with agents and brokers</li>
                    <li>Respond to inquiries</li>
                    <li>Improve website performance</li>
                    <li>Personalize user experienceSend notifications and updates</li>
                    <li>Prevent fraud and unauthorized access</li>
                    <li>Analyze user behavior and trends</li>
                    <li>Provide customer support</li>
                    <li>Comply with legal obligations</li>
                </ul>
            </>
        ),
    },
    {
        id: 5,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 10l9-7 9 7" />
                <path d="M5 10v10h14V10" />
            </svg>
        ),
        title: "Communication & Marketing",
        summary: "We may send",
        content: (
            <>
                <p>We may send:</p>
                <ul>
                    <li>Property recommendations</li>
                    <li>Inquiry updates</li>
                    <li>Promotional offers</li>
                    <li>Newsletter emails</li>
                    <li>Market insightsService announcements</li>
                </ul>
                <p>Users may unsubscribe from marketing communications at any time.</p>
            </>
        ),
    },
    {
        id: 6,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4" y1="20" x2="20" y2="4" />
            </svg>
        ),
        title: "Sharing of Information",
        summary: "We may share information with",
        content: (
            <>
                <p>We may share information with:</p>
                <ul>
                    <li>Real Estate Agents</li>
                    <li>Property Developers</li>
                    <li>Brokerage CompaniesService Providers</li>
                    <li>Payment Processors</li>
                    <li>Legal Authorities when required</li>
                </ul>
                <p>We do not sell personal information to third parties.</p>
            </>
        ),
    },
    {
        id: 7,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
        ),
        title: "Children’s Privacy",
        summary: `${companyName} services are not intended for individuals under 18 years of age.`,
        content: `${companyName} services are not intended for individuals under 18 years of age. We do not knowingly collect information from minors.`,
    },
    {
        id: 8,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M15 9a3 3 0 1 0-3 6" />
            </svg>
        ),
        title: "International Data Transfers",
        summary: "Your information may be processed and stored in countries outside.",
        content: "Your information may be processed and stored in countries outside your location where data protection laws may differ.By using our platform, you consent to such transfers.",
    },
    {
        id: 9,
        icon: (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 1.85-.51 3.65-1.38 5.21l-1.45-1.45a4.994 4.994 0 0 0-.64-6.29 5.003 5.003 0 0 0-7.07 0 5.003 5.003 0 0 0 0 7.07 5.006 5.006 0 0 0 6.29.64l1.72 1.72c-1.19 1.42-2.73 2.51-4.47 3.04-4.02-1.25-7-5.42-7-9.94V6.3l7-3.11 7 3.11V11zm-7 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"></path>
            </svg>
        ),
        title: "Changes to Privacy Policy",
        summary: "We may update this Privacy Policy periodically.",
        content: (
            <>
                <p>We may update this Privacy Policy periodically.</p>
                <p>Updated versions will be posted on this page with a revised effective date.</p>
                <p>Continued use of the platform after changes constitutes acceptance of the revised policy.</p>
            </>
        ),
    },
    {
        id: 10,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Personalization",
        summary: "We may update this Privacy Policy periodically.",
        content: (
            <>
                <p>We may update this Privacy Policy periodically</p>
                <ul>
                    <li>Recommend relevant properties</li>
                    <li>Show personalized content</li>
                    <li>Improve search results</li>
                    <li>Customize user dashboards</li>
                </ul>
            </>
        ),
    },
    {
        id: 11,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Marketing & Communications",
        summary: "We may send",
        content: (
            <>
                <p>We may send:</p>
                <ul>
                    <li>Property Alerts</li>
                    <li>Market Updates</li>
                    <li>Promotional Campaigns</li>
                    <li>Investment Opportunities</li>
                    <li>Newsletters</li>
                    <li>Event Invitations</li>
                    <li>Product Announcements</li>
                </ul>

                <p>Users may unsubscribe at any time.</p>
            </>
        ),
    },
    {
        id: 12,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Real Estate Advertising & Lead Sharing",
        summary: "When users submit property inquiries",
        content: (
            <>
                <p>When users submit property inquiries:</p>
                <ul>
                    <li>Inquiry information may be shared with the listing agent or developer</li>
                    <li>Brokers may contact users through phone, email, SMS, or WhatsApp</li>
                    <li>Communication records may be stored for support and quality assurance</li>
                </ul>

                <p>Lead quality and transaction outcomes are not guaranteed.</p>
            </>
        ),
    },
    {
        id: 13,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Third-Party Integrations",
        summary: `${companyName} may integrate with external services including`,
        content: (
            <>
                <p>{companyName} may integrate with external services including: </p>
                <ul>
                    <li>Google Maps</li>
                    <li>Social Media Platforms</li>
                    <li>WhatsApp</li>
                    <li>Analytics Platforms</li>
                    <li>Marketing Network</li>
                </ul>

                <p>Third-party services operate under their own privacy policies.</p>
            </>
        ),
    },
    {
        id: 14,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Third-Party Links",
        summary: "Lead Our platform may contain links to third-party website",
        content: (
            <>
                <p>Our platform may contain links to third-party website.</p>
                <p>
                    We are not responsible for:
                    <ul>
                        <li>External content</li>
                        <li>Third-party privacy practices</li>
                        <li>Security standards of external websites</li>
                    </ul>
                </p>
                <p>Users should review third-party privacy policies independently.</p>
            </>
        ),
    },
    {
        id: 15,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Automated Decision Making",
        summary: `${companyName} may use automated systems and AI technologies to:`,
        content: (
            <>
                <p>{companyName} may use automated systems and AI technologies to:</p>
                <ul>
                    <li>Recommend properties</li>
                    <li>Detect suspicious activities</li>
                    <li>Improve search results</li>
                    <li>Personalize user experiences</li>
                </ul>
                <p>These systems are designed to improve platform performance and security.</p>
            </>
        ),
    },
    {
        id: 16,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />
                <path d="M9 12l2 2 4-4" />
            </svg>
        ),
        title: "Contact Information",
        summary: "For privacy-related questions or requests, contact us",
        content: (
            <>
                <p>For privacy-related questions or requests, contact us:</p>
                <ul>
                    <li>
                        <b>Phone: </b>+971 50 361 5200
                    </li>
                    <li>
                        <b>Email: </b>info@leadtracks.ai
                    </li>
                    <li>
                        <b>Address: </b>5th floor office no 510, Opal Tower, Business Bay Dubai, UAE
                    </li>
                </ul>
            </>
        ),
    },
];

export default function PrivacyPolicy() {
    const [openSection, setOpenSection] = useState(null);

    const toggle = (id) => setOpenSection(openSection === id ? null : id);

    return (
        <div className={styles.page}>
            {/* Hero Banner */}
            <section className={styles.hero}>
                <div className="container">
                    <div className={styles.heroContent}>
                        <div className={styles.breadcrumb}>
                            <span>Home</span>
                            <span className={styles.chevron}>›</span>
                            <span className={styles.breadActive}>Privacy Policy</span>
                        </div>
                        <h1 className={styles.heroTitle}>
                            Privacy <span className={styles.heroTitleOrange}> Policy</span>
                        </h1>
                        <p className={styles.heroSubtitle}>Please read these terms carefully before using our platform and services.</p>
                        <div className={styles.heroDate}>Effective Date : May 2026</div>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <main className={styles.main}>
                <div className="container">
                    <div className={styles.main_title}>
                        <p>{companyName} (“we”, “our”, “us”) values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, share, and safeguard your information when you use our website, mobile applications, and related services.</p>
                        <p>By using {companyName}, you agree to the practices described in this Privacy Policy.</p>
                    </div>
                    <div className={styles.main_row}>
                        <aside className={styles.sidebar}>
                            <div className={styles.sidebarBox}>
                                <h3 className={styles.sidebarTitle}>On this page</h3>
                                <ul className={styles.sidebarList}>
                                    {SECTIONS.map((s) => (
                                        <li key={s.id} className={styles.sidebarItem}>
                                            <button
                                                onClick={() => {
                                                    toggle(s.id);
                                                    document.getElementById(`section-${s.id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
                                                }}
                                                className={`${styles.sidebarBtn} ${openSection === s.id ? styles.sidebarBtnActive : ""}`}
                                            >
                                                <span className={styles.sidebarNum}>{String(s.id).padStart(2, "0")}.</span>
                                                <span>{s.title}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </aside>
                        <div className={styles.accordion}>
                            {SECTIONS.map((s) => (
                                <div key={s.id} id={`section-${s.id}`} className={`${styles.accordionItem} ${openSection === s.id ? styles.accordionOpen : ""}`}>
                                    <button className={styles.accordionHeader} onClick={() => toggle(s.id)}>
                                        <div className={styles.accordionLeft}>
                                            <span className={styles.accordionIcon}>{s.icon}</span>
                                            <div>
                                                <h2 className={styles.accordionTitle}>
                                                    {s.id}. {s.title}
                                                </h2>
                                                {openSection !== s.id && <div className={styles.accordionSummary}>{s.summary}</div>}
                                            </div>
                                        </div>
                                        <span className={`${styles.chevronIcon} ${openSection === s.id ? styles.chevronUp : ""}`}>
                                            {openSection === s.id ? (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="18 15 12 9 6 15" />,
                                                </svg>
                                            ) : (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="6 9 12 15 18 9" />,
                                                </svg>
                                            )}
                                            {/* ⌄ */}
                                        </span>
                                    </button>
                                    {openSection === s.id && (
                                        <div className={styles.accordionBody}>
                                            <div>{s.content}</div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
            <Features />
        </div>
    );
}
